import i18n from 'i18next'
import detector from 'i18next-browser-languagedetector'
import { reactI18nextModule } from 'react-i18next'

import translationEN from '../translations/translationEN.json'
import translationES from '../translations/translationES.json'
import translationGL from '../translations/translationGL.json'
import translationPT from '../translations/translationPT.json'

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  gl: {
    translation: translationGL,
  },
  pt: {
    translation: translationPT,
  },
}

i18n
  .use(detector)
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n

// import i18n from 'i18next'
// import { initReactI18next, reactI18nextModule } from 'react-i18next'
//
// import detector from 'i18next-browser-languagedetector'
// import React from 'react'
//
// import translationEN from '../translations/translationEN.json'
// import translationES from '../translations/translationES.json'
//
// const resources = {
//   en: {
//     translation: translationEN,
//   },
//   es: {
//     translation: translationES,
//   },
// }
//
// i18n
//   .use(detector)
//   .use(reactI18nextModule)
//   .use(initReactI18next) // passes i18n down to react-i18next
//   .init({
//     resources,
//     lng: 'en',
//
//     keySeparator: false, // we do not use keys in form messages.welcome
//
//     interpolation: {
//       escapeValue: false, // react already safes from xss
//     },
//   })
//
// export default i18n
